import React from "react";
import MenuGrid from "../MenuGrid";

const SECTIONS = [
  {
    title: "Telas",
    items: [
      { label: "Colores",            icon: "fas fa-palette",     href: "/Colores",                     perm: "menu_colores"     },
      { label: "Tipo de Tela",       icon: "fab fa-staylinked",  href: "/TiposTelas",                  perm: "menu_tipos_telas" },
      { label: "Telas",              icon: "fas fa-tape",        href: "/ListadoTelas",                perm: "menu_telas"       },
      { label: "Inventario Telas",   icon: "fas fa-warehouse",   href: "/ListadoInventariosTelas",     perm: "menu_telas"       },
      // { label: "Inventario Telas Picos", icon: "fas fa-warehouse", href: "/ListadoInventariosTelasPicos", perm: "menu_telas"    },
      { label: "Seguimiento Telas",  icon: "fas fa-search",      href: "/ListadoSeguimientoTelas",     perm: "menu_telas"       },
      // { label: "Salida Tela",        icon: "fas fa-sign-out-alt", href: "/ListadoSalidaTelas",         perm: "menu_telas"       },
    ],
  },
  {
    title: "Habilitación",
    items: [
      { label: "Habilitación",            icon: "fas fa-tag",    href: "/ListadoHabilitacion",            perm: "menu_habilitacion" },
      { label: "Inventario Habilitación", icon: "fas fa-tags",   href: "/ListadoInventariosHabilitacion", perm: "menu_habilitacion" },
      { label: "Salida Habilitación",     icon: "fas fa-tags",   href: "/ListadoSalidaHabilitacion",      perm: "menu_habilitacion" },
      // { label: "Salida Habilitación Corte", icon: "fas fa-tags", href: "/ListadoSalidaHabilitacionCorte", perm: "menu_habilitacion" },
      { label: "Seguimiento Habilitación", icon: "fas fa-search", href: "/ListadoSeguimientoHabilitacion", perm: "menu_habilitacion" },
    ],
  },
  {
    title: "Artículos",
    items: [
      // { label: "Marcas",            icon: "far fa-copyright",       href: "/Marcas",                 perm: "menu_articulos" },
      { label: "Colecciones",       icon: "fas fa-calendar-alt",    href: "/Colecciones",            perm: "menu_articulos" },
      { label: "Departamentos",     icon: "fas fa-list-ul",         href: "/ListadoDepartamentos",   perm: "menu_articulos" },
      // { label: "Sub Departamentos", icon: "fas fa-list-ul",         href: "/ListadoSubDepartamentos", perm: "menu_articulos" },
      // { label: "Clases",            icon: "fas fa-bars",            href: "/ListadoClases",          perm: "menu_articulos" },
      // { label: "Etiquetas",         icon: "fas fa-bars",            href: "/ListadoSubClases",       perm: "menu_articulos" },
      { label: "Tallas",            icon: "fas fa-ruler-horizontal", href: "/ListadoTallas",         perm: "menu_articulos" },
      { label: "Artículos",         icon: "fas fa-tshirt",          href: "/ListadoArticulos",       perm: "menu_articulos" },
    ],
  },
  {
    title: "Clientes",
    items: [
      { label: "Zonas",       icon: "fas fa-map-marked-alt", href: "/Zonas",              perm: "menu_clientes" },
      { label: "Clientes",    icon: "fas fa-user-tie",       href: "/Clientes",           perm: "menu_clientes" },
      { label: "Compradores", icon: "fas fa-user-tie",       href: "/ListadoCompradores", perm: "menu_clientes" },
    ],
  },
  {
    title: "Proveedores",
    items: [
      { label: "Proveedores", icon: "fas fa-dolly", href: "/Proveedores", perm: "menu_proveedores" },
    ],
  },
  {
    title: "Producción",
    items: [
      { label: "Maquileros",        icon: "fas fa-dolly", href: "/Maquileros",       perm: "menu_proveedores" },
      { label: "Catálogo Procesos", icon: "fas fa-tasks", href: "/CatalogoProcesos", perm: "menu_produccion"  },
    ],
  },
];

function BotonesMateriales() {
  return (
    <MenuGrid
      title="Catálogos"
      subtitle="Telas, habilitación, artículos, clientes y proveedores"
      icon="fas fa-box"
      accent={{ color: "#10b981", bg: "#f0fdf4" }}
      gate="menu_articulos"
      sections={SECTIONS}
    />
  );
}

export default BotonesMateriales;
